import React, { ReactElement } from 'react';

// Components
import { Sheet } from '../../../../../mobile/structural/sheet/Sheet';
import { UseSheetReturnType } from '../../../../../mobile/structural/sheet/hooks/useSheet';

// Styles
import LineWeightPopupContent from './LineWeightPopupContent';

import './MobileLineWeightSheet.scss';

export type MobileLineWeightSheetProps = {
    sheetProps: UseSheetReturnType;
};

const MobileLineWeightSheet = (props: MobileLineWeightSheetProps): ReactElement => {
    const { sheetProps } = props;

    return (
        <Sheet className="MobileLineWeightSheet" {...sheetProps}>
            <Sheet.Overlay />
            <Sheet.Panel>
                <Sheet.Content>
                    <div className="line-weight-content">
                        <LineWeightPopupContent close={sheetProps.closeSheet} />
                    </div>
                </Sheet.Content>
            </Sheet.Panel>
        </Sheet>
    );
};

export default MobileLineWeightSheet;
